/**
 * @author liuys
 * 营销裂变
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async getFormDetail(keyId) {
        return request(api.operate.MARKETINGFISSION + '/' + keyId, METHOD.GET);
    },
    async saveFormDetail(result) {
        return request(api.operate.MARKETINGFISSION, METHOD.POST, result);
    },
    async saveDataLast(result) {
        return request(api.operate.MARKETINGFISSION + '/saveDataLast', METHOD.POST, result);
    },
    async updateStatus(ids, status) {
        return request(api.operate.MARKETINGFISSION + '/updateStatusFission?fissionIds=' + ids + '&status=' + status, METHOD.GET);
    },
    async createMsgTask(id) {
        return request(api.operate.MARKETINGFISSION + '/createMsgTask?fissionId=' + id, METHOD.GET);
    },
    async send(result) {
        return request(api.operate.MARKETINGFISSIONWIN + '/updateStatus?winIds='+result, METHOD.GET);
    },
    /**
     * 获取标签下拉
     * @param result
     * @return {Promise<AxiosResponse<T>>}
     */
    async getTagList(result) {
        return request(api.client.LABEL + '/getWxTagAll', METHOD.GET, result);
    },
    async getLabelAllList() {
        return request(api.operate.TAGAll, METHOD.GET);  //获取标签 所有
    },
    async updateStatusFission(result) {
        return request(api.operate.MARKETINGFISSION + '/updateStatusFission', METHOD.GET, result);
    },
    //  裂变预览接口
    async previewFission(id) {
        return request(api.operate.MARKETINGFISSION + '/createQrImgCode?fissionId=' + id, METHOD.GET);
    },
}

export default {dataApi}